<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Editar hilo</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <h4>Características</h4>

            <b-form-row>
              <!-- Reference -->
              <b-form-group
                id="input-reference"
                class="col-3"
                label="Nombre de hilo"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  v-model="$v.form.reference.$model"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <!-- Code hex -->
              <b-form-group
                id="input-code_hex"
                class="col-3"
                label="Color"
                label-for="code_hex"
              >
                <b-form-input
                  type="color"
                  id="code_hex"
                  v-model="$v.form.code_hex.$model"
                  :state="validateState('code_hex')"
                  aria-describedby="input-code_hex-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-code_hex-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <!-- Code hex -->
              <b-form-group
                id="input-icon"
                class="col-3"
                label="Icono bobina"
                description="Dejar vacío para mantener el icono actual"
                label-for="icon"
              >
                <b-form-file
                  accept="image/*"
                  id="icon"
                  v-model="$v.form.icon.$model"
                  @input="changedImage"
                  :state="validateState('icon')"
                  aria-describedby="input-icon-feedback"
                  drop-placeholder="Arrastra un archivo aquí..."
                ></b-form-file>
                <b-form-invalid-feedback id="input-icon-feedback"
                  >Debes seleccionar una imagen válida (formato PNG o
                  JPEG).</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                label="Vista previa icono bobina"
                id="input-preview"
                class="col-auto"
              >
                <div>
                  <img style="max-height: 5rem" :src="form.iconURI" />
                </div>
              </b-form-group>
            </b-form-row>
            <!-- <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-name_' + lang"
                :label="
                  languageCodes.length > 1
                    ? 'Nombre (' + languageNames[i] + ')'
                    : 'Nombre'
                "
                :label-for="'name_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'name_' + lang"
                  v-model="$v.form['name_' + lang].$model"
                  :state="validateState('name_' + lang)"
                  :aria-describedby="'input-name_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-name_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row> -->

            <b-form-row>
              <b-form-group
                id="input-provider"
                class="col-3"
                label="Proveedor"
                label-for="provider"
              >
                <b-form-input
                  id="provider"
                  v-model="$v.form.provider.$model"
                  :state="validateState('provider')"
                  aria-describedby="input-provider-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-provider-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-ref_provider"
                class="col-3"
                label="Ref. proveedor"
                label-for="ref_provider"
              >
                <b-form-input
                  id="ref_provider"
                  v-model="$v.form.ref_provider.$model"
                  :state="validateState('ref_provider')"
                  aria-describedby="input-ref_provider-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-ref_provider-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <h4 class="mt-3">Precios</h4>

            <b-form-row>
              <b-form-group
                id="input-meters_per_roll"
                class="col-3"
                label="Metros (por rollo)"
                label-for="meters_per_roll"
              >
                <b-input-group>
                  <b-form-input
                    id="meters_per_roll"
                    :value="$v.form.meters_per_roll.$model.replace('.', ',')"
                    @change="
                      setDecimal('meters_per_roll', $event);
                      calcIncreaseProcessed();
                    "
                    :state="validateState('meters_per_roll')"
                    aria-describedby="input-meters_per_roll-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>m</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-meters_per_roll-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-cost_roll"
                class="col-3"
                label="Coste (por rollo)"
                label-for="cost_roll"
              >
                <b-input-group>
                  <b-form-input
                    id="cost_roll"
                    :value="$v.form.cost_roll.$model.replace('.', ',')"
                    @change="
                      setDecimal('cost_roll', $event);
                      calcIncreaseProcessed();
                    "
                    :state="validateState('cost_roll')"
                    aria-describedby="input-cost_roll-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>€</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-cost_roll-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-cost_per_meter"
                class="col-3"
                label="Coste (por metro)"
                label-for="cost_per_meter"
                description="IA_COSTE_METRO_HILO (IA_COSTE_CM_HILO)"
              >
                <b-input-group>
                  <b-form-input
                    id="cost_per_meter"
                    :disabled="true"
                    :value="$v.form.cost_per_meter.$model.replace('.', ',')"
                    aria-describedby="input-cost_per_meter-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>€</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-cost_per_meter-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row class="mt-2 pb-2">
              <b-col cols="2">Incremento sobre coste</b-col>
              <b-col cols="2">Precio (por metro)</b-col>
              <b-col cols="2">PVP Euros/metro</b-col>
            </b-form-row>

            <b-form-row class="pb-4">
              <b-col cols="2"
                ><b-form-group
                  id="input-price_increase"
                  class="col-8 pl-0"
                  label-for="price_increase"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_increase"
                      :value="$v.form.price_increase.$model.replace('.', ',')"
                      @change="
                        setDecimal('price_increase', $event);
                        calcIncreaseProcessed();
                      "
                      :state="validateState('price_increase')"
                      aria-describedby="input-price_increase-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>%</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback id="input-price_increase-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2"
                ><b-form-group
                  id="input-price_per_meter"
                  class="col-8 pl-0"
                  label-for="price_per_meter"
                  description="IA_PRECIO_METRO_HILO (IA_PRECIO_CM_HILO)"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_per_meter"
                      :value="$v.form.price_per_meter.$model.replace('.', ',')"
                      :disabled="true"
                      aria-describedby="input-price_per_meter-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback id="input-price_per_meter-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="2"
                ><b-form-group
                  id="input-price_per_meter_retail_final"
                  class="col-8 pl-0"
                  label-for="price_per_meter_retail_final"
                >
                  <b-input-group>
                    <b-form-input
                      id="price_per_meter_retail_final"
                      :value="
                        $v.form.price_per_meter_retail_final.$model.replace(
                          '.',
                          ','
                        )
                      "
                      :disabled="true"
                      aria-describedby="input-price_per_meter_retail_final-feedback"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>€</b-input-group-text>
                    </template>
                  </b-input-group>

                  <b-form-invalid-feedback
                    id="input-price_per_meter_retail_final-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-button type="submit" variant="primary">Guardar hilo</b-button>
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';
import { helpers } from 'vuelidate/lib/validators';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import * as Sentry from '@sentry/browser';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminColorsEditScreen',
  props: ['id'],
  components: {},
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: { required },
      code_hex: { required },
      icon: {
        isValidImage,
      },
      provider: {},
      ref_provider: {},
      meters_per_roll: {},
      cost_roll: {},
      cost_per_meter: {},
      price_increase: {},
      price_per_meter: {},
      price_per_meter_retail_final: {},
    };

    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      code_hex: '#FFFFFF',
      reference: '',
      provider: '',
      icon: null,
      iconURI: null,
      ref_provider: '',
      meters_per_roll: '',
      cost_roll: '',
      cost_per_meter: '',
      price_increase: '',
      price_per_meter: '',
      price_per_meter_retail_final: '',
      error: {
        show: false,
        text: '',
      },
    };

    // store.getLanguageCodes().map((x) => {
    //   form['name_' + x] = '';
    // });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {
    actions.getColor(this.id).then((x) => {
      const data = x.data;

      this.form.reference = data.reference;
      this.form.code_hex = '#' + data.code_hex;
      this.form.iconURI = data.icon;

      this.form.provider = data.provider;
      this.form.ref_provider = data.ref_provider;
      this.form.meters_per_roll = data.meters_per_roll;
      this.form.cost_roll = data.cost_roll;
      this.form.cost_per_meter = data.cost_per_meter;
      this.form.price_increase = data.price_increase;
      this.form.price_per_meter = data.price_per_meter;
      this.form.price_per_meter_retail_final =
        data.price_per_meter_retail_final;

      // this.languageCodes.map((y) => {
      //   this.form['name_' + y] = data['name_' + y];
      // });
    });
  },
  methods: {
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.iconURI = result;
      });
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    calcIncreaseProcessed() {
      if (
        parseFloat(this.$v.form['meters_per_roll'].$model) > 0 &&
        parseFloat(this.$v.form['cost_roll'].$model) > 0
      ) {
        this.$v.form['cost_per_meter'].$model = (
          parseFloat(this.$v.form['cost_roll'].$model) /
          parseFloat(this.$v.form['meters_per_roll'].$model)
        ).toFixed(4);
      }

      if (
        parseFloat(this.$v.form['cost_per_meter'].$model) > 0 &&
        parseFloat(this.$v.form['price_increase'].$model) > 0
      ) {
        this.$v.form['price_per_meter'].$model = (
          parseFloat(this.$v.form['cost_per_meter'].$model) *
          (1 + parseFloat(this.$v.form['price_increase'].$model) / 100.0)
        ).toFixed(4);
      }

      if (parseFloat(this.$v.form['price_per_meter'].$model) > 0) {
        this.$v.form['price_per_meter_retail_final'].$model = (
          parseFloat(this.$v.form['price_per_meter'].$model) * 1.21
        ).toFixed(4);
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = new FormData();

      data.append('reference', this.form.reference);
      data.append('code_hex', this.form.code_hex.replace('#', ''));
      data.append('provider', this.form.provider);
      if (this.form.icon !== null) {
        data.append('icon', this.form.icon);
      }
      data.append('ref_provider', this.form.ref_provider);
      data.append('meters_per_roll', this.form.meters_per_roll);
      data.append('cost_roll', this.form.cost_roll);
      data.append('cost_per_meter', this.form.cost_per_meter);
      data.append('price_increase', this.form.price_increase);
      data.append('price_per_meter', this.form.price_per_meter);
      data.append(
        'price_per_meter_retail_final',
        this.form.price_per_meter_retail_final
      );

      // this.languageCodes.map((x) => {
      //   data['name_' + x] = this.form['name_' + x];
      // });

      // data['name'] = this.form['name_' + this.languageCodes[0]];
      Sentry.setExtra('data', JSON.stringify(Object.fromEntries(data)));

      actions.patchColor(this.id, data).then(() => {
        this.$router.push({ name: 'AdminColorsScreen' });
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
